import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalComponent } from '../../global-component';
import { CurrentUser } from '../models/currentuser.models';
import { Observable } from 'rxjs';
import { TokenStorageService } from './token-storage.service';
import { DesignLegend } from '../models/designlegends.models';

const BASE_URL = GlobalComponent.BASE_API_URL;
@Injectable({ providedIn: 'root' })

/**
 * Planset-service Component
 */
export class LegendService {

    currentuser!: CurrentUser;

    constructor(private http: HttpClient, private tokenService: TokenStorageService) {
        this.currentuser = this.tokenService.getCurrentUser();
    }

    //FETCH PLACARDS 
    getAllLegends(postdata: any): Observable<any[]> {
        const { page, pageSize, query, activestate } = postdata;
        let paramstring = "legends?sort[0]=createdAt:DESC&pagination[page]=" + page + "&pagination[pageSize]=" + pageSize
        if (query) {
            paramstring += "&_q=" + query;
        }
        if (activestate !== undefined) {
            paramstring += "&filters[activestate][$eq]=" + activestate;
        }
        console.log("PARAMS", paramstring);
        return this.http.get<any[]>(BASE_URL + paramstring);
    }

    //ADD PLACARD RECORD
    createLegend(postdata: any) : Observable<any[]> {
        // return this.http.post(BASE_URL + "legends?filters[status][$eq]=true&sort[0]=updatedAt:DESC", { });
        return this.http.post<any>(BASE_URL + 'legends', {
            data: postdata
          });
    }

     //UPDATE PLACARD RECORD
     updateLegend(postdata: any, id: number) : Observable<any[]> {
        // return this.http.post(BASE_URL + "legends?filters[status][$eq]=true&sort[0]=createdAt:DESC", { });
        return this.http.put<any>(BASE_URL + 'legends/' + id, {
            data: postdata
          });
    }
}